import { render } from "./wDate.vue?vue&type=template&id=11f09860&ts=true"
import script from "./wDate.vue?vue&type=script&lang=ts"
export * from "./wDate.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__